import React, { useState, useEffect } from "react";
import PopupImage from "../../images/form.jpg"; // Ensure correct path

export default function PopupLeadForm() {
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
      if (window.innerWidth >= 768) {
        document.body.style.overflow = "hidden";
      }
    }, 1500);

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = "auto";
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, phone } = formData;

    if (phone.length !== 10) {
      alert("Please enter a valid 10-digit phone number.");
      return;
    }

    const message = `New Lead from Website:\n\nName: ${name}\nEmail: ${email}\nPhone: ${phone}`;
    const whatsappUrl = `https://wa.me/919845751751?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappUrl, "_blank");

    document.body.style.overflow = "auto";
    setShowPopup(false);
  };

  const handleClose = () => {
    document.body.style.overflow = "auto";
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black bg-opacity-80 flex items-center justify-center overflow-y-auto">
      <div className="bg-white rounded-lg w-full max-w-sm md:max-w-3xl shadow-lg flex flex-col md:flex-row overflow-hidden relative m-4">
        {/* Close Button */}
       

        <button
          onClick={handleClose}
          aria-label="Close popup"
          class="absolute top-2 right-2 w-10 h-10 flex items-center justify-center text-gray-500 hover:text-red-600 text-2xl font-bold"
        >
          &times;
        </button>

        {/* Left Image (hidden on mobile) */}
        <div className="hidden md:block md:w-1/2">
          <img
            src={PopupImage}
            alt="Site Visit"
            title="Site Visit"
            className="h-full w-full object-cover"
            loading="eager"
          />
        </div>

        {/* Right Form */}
        <div className="w-full md:w-1/2 p-5 flex flex-col justify-center">
          <form onSubmit={handleSubmit} className="space-y-3">
            <input
              type="text"
              placeholder="Your Name"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              required
              className="w-full border rounded px-4 py-3 focus:outline-none focus:ring-2 focus:ring-violet-500"
            />
            <input
              type="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              required
              className="w-full border rounded px-4 py-3 focus:outline-none focus:ring-2 focus:ring-violet-500"
            />
            <input
              type="tel"
              placeholder="Your Phone Number"
              value={formData.phone}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                  setFormData({ ...formData, phone: value });
                }
              }}
              required
              className="w-full border rounded px-4 py-3 focus:outline-none focus:ring-2 focus:ring-violet-500"
            />
            <button
              type="submit"
              className="w-full bg-violet-600 hover:bg-violet-700 text-white font-semibold py-2 rounded transition"
            >
              Submit
            </button>
          </form>
          <p className="text-xs text-gray-600 mt-3 text-center">
            ✅ I authorize company representatives to Call, SMS, Email or
            WhatsApp me about its products and offers. This consent overrides
            any registration for DNC/NDNC.
          </p>
        </div>
      </div>
    </div>
  );
}
